import { render, staticRenderFns } from "./ImprestPendingApprovalsList.vue?vue&type=template&id=5acb9278&scoped=true"
import script from "./ImprestPendingApprovalsList.vue?vue&type=script&lang=js"
export * from "./ImprestPendingApprovalsList.vue?vue&type=script&lang=js"
import style0 from "./ImprestPendingApprovalsList.vue?vue&type=style&index=0&id=5acb9278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb9278",
  null
  
)

export default component.exports